import { useState, useEffect, createRef } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { setAlert } from '../../actions/alert';
import { editarArchivo, obtenerArchivo } from '../../actions/expediente';

const EditarArchivo = ({ archivo, reestablecerArchivo }) => {

    const dispatch =  useDispatch();

    const { detalles } = useSelector(state => state.expediente);

    const [archivoData, setArchivoData] = useState({
        id_archivo: null,
        nombre: null,
        descripcion: null,
        archivo: null,
        extension: null,
        url: null,
        precargado: false
    });

    const [archivoModal, setArchivoModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    let archivo_ref = createRef();

    /* Agregar archivo */
    const handleInputChange = ({ target }) => {
        setArchivoData({
            ...archivoData,
            [target.name]: target.value
        });
    }

    const handleArchivoElegir = () => {
        return archivo_ref.current?.click();
    }

    const handleChangeFile = () => {
        const file = archivo_ref.current.files[0];
        if (!file) return;

        const ext = file.name.split('.').pop().toLowerCase();
        if (!['pdf', 'jpg', 'jpeg', 'png'].includes(ext)) {
            dispatch(setAlert('Solo se aceptan archivos PDF, JPG o PNG.', 'danger'));
            archivo_ref.current.value = '';
            return;
        }

        setArchivoData({
            ...archivoData,
            archivo: file,
            extension: ext,
            url: URL.createObjectURL(file)
        });
    }

    const handleViewFile = (url) => {
        if(url){
            window.open(url);
        }else{
            dispatch(setAlert('No file selected', 'danger'));
        }
    }

    const handleProcesar = async () => {
        await setStatusProcesar(true);
        
        let formData = new FormData();

        formData.append('id_archivo', archivoData.id_archivo);
        formData.append('nombre', archivoData.nombre);
        formData.append('descripcion', archivoData.descripcion);
        formData.append('extension', archivoData.extension);
        formData.append('archivo', archivoData.archivo);

        await dispatch(editarArchivo(formData));

        await handleCerrar(null);
        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            setArchivoData({
                id_archivo: null,
                nombre: null,
                descripcion: null,
                archivo: null,
                extension: null,
                url: null,
                precargado: false
            });

            reestablecerArchivo(null);

            setArchivoModal(false);
        }
    }

    useEffect(() => {
        if(archivo){
            // Archivos precargados no tienen URL en S3 — no llamar obtenerArchivo
            if(!archivo.precargado){
                dispatch(obtenerArchivo({ id_archivo: archivo.id_archivo }));
            }

            setArchivoData({
                ...archivoData,
                id_archivo: archivo.id_archivo,
                nombre: archivo.nombre,
                descripcion: archivo.descripcion,
                archivo: archivo.archivo,
                extension: archivo.extension,
                url: archivo.url,
                precargado: !!archivo.precargado
            });

            setArchivoModal(true);
        }
    }, [archivo]);

    useEffect(() => {        
        if(detalles && detalles?.extension && detalles?.url){
            setArchivoData({
                ...archivoData, 
                extension: detalles.extension,
                url: detalles.url
            });
        }
    }, [detalles]);

    const esPrecargado = archivoData.precargado;

    return (
        <Modal show={archivoModal} backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {esPrecargado ? 'Subir archivo' : 'Editar archivo'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {esPrecargado && (
                    <div className="alert alert-warning d-flex align-items-center gap-2 py-2 mb-3" role="alert" style={{ fontSize: '0.875rem' }}>
                        <i className="fa-solid fa-circle-info flex-shrink-0"></i>
                        <span>Este documento fue solicitado por Goodlic. Selecciona el archivo para subirlo.</span>
                    </div>
                )}

                <div className="col-md-12 form-group mb-3">
                    <div className="input-group">
                        <div className="form-floating">
                            <input
                                className="form-control"
                                type="text"
                                placeholder="Nombre"
                                id="nombre"
                                name="nombre"
                                value={archivoData.nombre || ''}
                                onChange={e => handleInputChange(e)}
                                disabled={esPrecargado}
                            />
                            <label htmlFor="nombre">Nombre</label>
                        </div>
                    </div>
                </div>

                <div className="col-md-12 form-group mb-3">
                    <div className="input-group">
                        <div className="form-floating">
                            <textarea
                                className="form-control textareCampo"
                                placeholder="Descripción"
                                id="descripcion"
                                name="descripcion"
                                value={archivoData.descripcion || ''}
                                onChange={e => handleInputChange(e)}
                                disabled={esPrecargado}
                            ></textarea>
                            <label htmlFor="descripcion">Descripción</label>
                        </div>
                    </div>
                </div>

                <div className="col-md-12">
                    <div className="btn-group w-100" role="group">
                        <button
                            type="button"
                            className={`btn ${esPrecargado ? 'btn-warning' : 'btn-outline-secondary'}`}
                            onClick={() => handleArchivoElegir()}
                        >
                            <i className={`fa-solid ${archivoData.archivo ? 'fa-rotate' : 'fa-upload'} me-1`}></i>
                            {archivoData.archivo ? 'Cambiar archivo' : (esPrecargado ? 'Seleccionar archivo' : (archivoData.url ? 'Archivo existente' : 'Elegir archivo'))}
                        </button>
                        {(archivoData.archivo || (!esPrecargado && archivoData.url)) && (
                            <button type="button" className="btn btn-secondary" onClick={() => handleViewFile(archivoData.url)}>
                                <i className="fa-solid fa-eye"></i> Ver
                            </button>
                        )}
                    </div>
                    {esPrecargado && !archivoData.archivo && (
                        <small className="text-danger mt-1 d-block">
                            <i className="fa-solid fa-circle-exclamation me-1"></i>Debes seleccionar un archivo para continuar.
                        </small>
                    )}
                    <input type="file" className="d-none" id="archivo" name="archivo" ref={archivo_ref} accept=".pdf,.jpg,.jpeg,.png" onChange={handleChangeFile} />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-danger" onClick={() => handleCerrar()} disabled={statusProcesar}>
                    <i className="fas fa-times fa-sm"></i> Cancelar
                </button>
                {statusProcesar
                    ? <button type="button" className="btn btn-success" disabled>
                        <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                        Guardando...
                      </button>
                    : <button
                        type="button"
                        className="btn btn-success"
                        onClick={() => handleProcesar()}
                        disabled={esPrecargado && !archivoData.archivo}
                      >
                        <i className="fas fa-check fa-sm me-1"></i>
                        {esPrecargado ? 'Subir archivo' : 'Guardar'}
                      </button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default EditarArchivo;